import React from 'react';
import { ClockIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-139">
          <h2 id="problem" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-140">
            Warum Fachanwälte heute automatisieren müssen
          </h2>
          <h3 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-141">
            Verkehrsrechtliche Standardprozesse kosten Sie täglich wertvolle
            Zeit
          </h3>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-142">
          <div className="bg-gray-50 rounded-xl p-8 mb-8" data-id="element-143">
            <p className="text-lg text-gray-700 mb-4" data-id="element-144">
              Egal ob Bußgeld, Unfallregulierung oder MPU – ein Großteil der
              Tätigkeiten in verkehrsrechtlichen Mandaten wiederholt sich.
            </p>
            <p className="text-lg text-gray-700 mb-4" data-id="element-145">
              Manuelle Aktenanlage, Rückfragen, Fristen, Schriftsätze,
              Dokumentation: Das alles frisst Zeit und bindet wertvolle
              Ressourcen.
            </p>
            <p className="text-lg font-semibold text-gray-900 mb-4" data-id="element-146">
              Während das Fallvolumen steigt, sinken gleichzeitig die Margen.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-147">
            <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg" data-id="element-148">
              <ClockIcon className="w-8 h-8 text-red-600 mb-3" data-id="element-149" />
              <h4 className="font-semibold text-gray-900 mb-2" data-id="element-150">
                Hoher Zeitaufwand
              </h4>
              <p className="text-gray-700" data-id="element-151">
                30+ Minuten pro Fall für repetitive Aufgaben
              </p>
            </div>
            <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg" data-id="element-152">
              <TrendingDownIcon className="w-8 h-8 text-red-600 mb-3" data-id="element-153" />
              <h4 className="font-semibold text-gray-900 mb-2" data-id="element-154">
                Sinkende Margen
              </h4>
              <p className="text-gray-700" data-id="element-155">
                Mehr Fälle, aber weniger Gewinn pro Mandat
              </p>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-156">
            <p className="text-2xl font-bold text-blue-600" data-id="element-157">
              Legallama löst dieses Problem.
            </p>
            <p className="text-lg text-gray-700 mt-4" data-id="element-158">
              Wir automatisieren die ersten 6–12 Schritte eines jeden
              Verkehrssachverhalts – vollständig, fehlerfrei und in Sekunden.
            </p>
          </div>
        </div>
      </div>
    </section>;
}